"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
const adstudio_1 = require("../enums/adstudio");
const INITIAL_MATRIX_3D = '1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1';
function isIOS() {
    return !!/iPad|iPhone|iPod/.test(navigator.userAgent);
}
const availableAnimations = [
    {
        nameShown: 'Bounce',
        name: 'bounceX',
        category: 'Attention Seekers',
        [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: () => {
            const animation = {
                keyframes: [
                    { translateY: `-300px`, easing: 'easeOutExpo' },
                    { translateY: '0', easing: 'easeOutBounce' },
                ],
            };
            return animation;
        },
    },
    {
        nameShown: 'Flash',
        name: 'flashX',
        category: 'Attention Seekers',
        [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: () => {
            return {
                keyframes: [{ opacity: 0 }, { opacity: 1 }, { opacity: 0 }, { opacity: 1 }],
            };
        },
    },
    {
        nameShown: 'Pulse',
        name: 'pulseX',
        category: 'Attention Seekers',
        [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ duration }) => {
            const keyframeDuration = duration / 8;
            const firstBeatRelativeDuration = 0.5;
            const secondBeatRelativeDuration = 4 - firstBeatRelativeDuration;
            const animation = {
                keyframes: [
                    {
                        scaleX: 1.2,
                        scaleY: 1.2,
                        easing: 'linear',
                        duration: keyframeDuration * firstBeatRelativeDuration,
                    },
                    {
                        scaleX: 1,
                        scaleY: 1,
                        easing: 'easeOutElastic',
                        duration: keyframeDuration * secondBeatRelativeDuration,
                    },
                    {
                        scaleX: 1.2,
                        scaleY: 1.2,
                        easing: 'linear',
                        duration: keyframeDuration * firstBeatRelativeDuration,
                    },
                    {
                        scaleX: 1,
                        scaleY: 1,
                        easing: 'easeOutElastic',
                        duration: keyframeDuration * secondBeatRelativeDuration,
                    },
                ],
            };
            return animation;
        },
    },
    {
        nameShown: 'Rubber Band',
        name: 'rubberBandX',
        category: 'Attention Seekers',
        [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ duration }) => {
            const tenPercentDuration = duration / 10;
            const animation = {
                keyframes: [
                    {
                        scaleX: 1.25,
                        scaleY: 0.75,
                        scaleZ: 1,
                        duration: tenPercentDuration * 3, // 30%
                    },
                    {
                        scaleX: 0.75,
                        scaleY: 1.25,
                        scaleZ: 1,
                        duration: tenPercentDuration, // 40%
                    },
                    {
                        scaleX: 1.15,
                        scaleY: 0.85,
                        scaleZ: 1,
                        duration: tenPercentDuration, // 50%
                    },
                    {
                        scaleX: 0.95,
                        scaleY: 1.05,
                        scaleZ: 1,
                        duration: tenPercentDuration * 1.5, // 65%
                    },
                    {
                        scaleX: 1.05,
                        scaleY: 0.95,
                        scaleZ: 1,
                        duration: tenPercentDuration, // 75%
                    },
                    {
                        scaleX: 1,
                        scaleY: 1,
                        scaleZ: 1,
                        duration: tenPercentDuration * 2.5, // 75%
                    },
                ],
                easing: 'linear',
            };
            return animation;
        },
    },
    {
        nameShown: 'Shake',
        name: 'shakeX',
        category: 'Attention Seekers',
        [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ duration }) => {
            const tenPercentDuration = duration / 10;
            const numberOfKeyframes = 10;
            const animation = {
                keyframes: [...Array(numberOfKeyframes).keys()].map((index) => ({
                    translateX: index % 2 === 0 ? `-10%` : index === numberOfKeyframes - 1 ? `0%` : '10%',
                    duration: tenPercentDuration,
                })),
                easing: 'linear',
            };
            return animation;
        },
    },
    {
        nameShown: 'Bobble',
        name: 'swingX',
        category: 'Attention Seekers',
        [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ duration }) => {
            const tenPercentDuration = duration / 10;
            const animation = {
                keyframes: [
                    {
                        rotateZ: `15deg`,
                        duration: tenPercentDuration * 2, // 20%
                    },
                    {
                        rotateZ: `-10deg`,
                        duration: tenPercentDuration * 2, // 40%
                    },
                    {
                        rotateZ: `5deg`,
                        duration: tenPercentDuration * 2, // 60%
                    },
                    {
                        rotateZ: `-5deg`,
                        duration: tenPercentDuration * 2, // 80%
                    },
                    {
                        rotateZ: `0deg`,
                        duration: tenPercentDuration * 2, // 100%
                    },
                ],
                easing: 'linear',
            };
            return animation;
        },
    },
    {
        nameShown: 'Ta-Da',
        name: 'tadaX',
        category: 'Attention Seekers',
        [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ duration }) => {
            const tenPercentDuration = duration / 10;
            const animation = {
                keyframes: [
                    {
                        scaleX: 0.9,
                        scaleY: 0.9,
                        rotateZ: `-3deg`,
                        duration: tenPercentDuration * 1, // 10%
                    },
                    {
                        scaleX: 0.9,
                        scaleY: 0.9,
                        rotateZ: `-3deg`,
                        duration: tenPercentDuration * 1, // 20%
                    },
                    {
                        scaleX: 1.1,
                        scaleY: 1.1,
                        rotateZ: `3deg`,
                        duration: tenPercentDuration * 1, // 30%
                    },
                    {
                        scaleX: 1.1,
                        scaleY: 1.1,
                        rotateZ: `-3deg`,
                        duration: tenPercentDuration * 1, // 40%
                    },
                    {
                        scaleX: 1.1,
                        scaleY: 1.1,
                        rotateZ: `3deg`,
                        duration: tenPercentDuration * 1, // 50%
                    },
                    {
                        scaleX: 1.1,
                        scaleY: 1.1,
                        rotateZ: `-3deg`,
                        duration: tenPercentDuration * 1, // 60%
                    },
                    {
                        scaleX: 1.1,
                        scaleY: 1.1,
                        rotateZ: `3deg`,
                        duration: tenPercentDuration * 1, // 70%
                    },
                    {
                        scaleX: 1.1,
                        scaleY: 1.1,
                        rotateZ: `-3deg`,
                        duration: tenPercentDuration * 1, // 80%
                    },
                    {
                        scaleX: 1.1,
                        scaleY: 1.1,
                        rotateZ: `3deg`,
                        duration: tenPercentDuration * 1, // 30%
                    },
                    {
                        scaleX: 1,
                        scaleY: 1,
                        rotateZ: `0deg`,
                        duration: tenPercentDuration * 2, // 100%
                    },
                ],
                easing: 'linear',
            };
            return animation;
        },
    },
    {
        nameShown: 'Sway',
        name: 'wobbleX',
        category: 'Attention Seekers',
        [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ duration }) => {
            const tenPercentDuration = duration / 10;
            const animation = {
                keyframes: [
                    {
                        translateX: '-25%',
                        rotateZ: `${-5}deg`,
                        duration: tenPercentDuration * 1.5, // 15%
                    },
                    {
                        translateX: '20%',
                        rotateZ: `${3}deg`,
                        duration: tenPercentDuration * 1.5, // 30%
                    },
                    {
                        translateX: '-15%',
                        rotateZ: `${-3}deg`,
                        duration: tenPercentDuration * 1.5, // 45%
                    },
                    {
                        translateX: '10%',
                        rotateZ: `${2}deg`,
                        duration: tenPercentDuration * 1.5, // 60%
                    },
                    {
                        translateX: '-5%',
                        rotateZ: `${-1}deg`,
                        duration: tenPercentDuration * 1.5, // 75%
                    },
                    {
                        translateX: '0%',
                        rotateZ: `0deg`,
                        duration: tenPercentDuration * 2.5, // 100%
                    },
                ],
                easing: 'linear',
            };
            return animation;
        },
    },
    {
        nameShown: 'Jiggle',
        name: 'jelloX',
        category: 'Attention Seekers',
        [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ duration }) => {
            const keyFrameDuration = (duration * 11.1) / 100;
            const animation = {
                keyframes: [
                    {
                        skewX: `0deg`,
                        skewY: `0deg`,
                        duration: keyFrameDuration, // 11.1%
                    },
                    {
                        skewX: `${-12.5}deg`,
                        skewY: `${-12.5}deg`,
                        duration: keyFrameDuration, // 22.2%
                    },
                    {
                        skewX: `${6.25}deg`,
                        skewY: `${6.25}deg`,
                        duration: keyFrameDuration, // 33.3%
                    },
                    {
                        skewX: `${-3.125}deg`,
                        skewY: `${-3.125}deg`,
                        duration: keyFrameDuration, // 44.4%
                    },
                    {
                        skewX: `${1.5625}deg`,
                        skewY: `${1.5625}deg`,
                        duration: keyFrameDuration, // 55.5%
                    },
                    {
                        skewX: `${-0.78125}deg`,
                        skewY: `${-0.78125}deg`,
                        duration: keyFrameDuration, // 66.6%
                    },
                    {
                        skewX: `${0.390625}deg`,
                        skewY: `${0.39}625`,
                        duration: keyFrameDuration, // 77.7%
                    },
                    {
                        skewX: `${-0.1953125}deg`,
                        skewY: `${-0.1953125}deg`,
                        duration: keyFrameDuration, // 88.8%
                    },
                    {
                        skewX: `0deg`,
                        skewY: `0deg`,
                        duration: duration - keyFrameDuration * 8, // 100%
                    },
                ],
                easing: 'linear',
            };
            return animation;
        },
    },
    {
        nameShown: 'Flip',
        name: 'flipX',
        category: 'Attention Seekers',
        [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ duration }) => {
            const tenPercentDuration = (duration * 10) / 100;
            const animation = {
                keyframes: [
                    {
                        duration: tenPercentDuration * 2,
                        perspective: '400px',
                    },
                    {
                        duration: tenPercentDuration * 6, // 80%
                        perspective: '400px',
                        rotateY: `+=1turn`,
                        scaleX: 0.95,
                        scaleY: 0.95,
                        scaleZ: 0.95,
                        easing: `cubicBezier(0, 0, 0.58, 1.0)`,
                    },
                    {
                        duration: tenPercentDuration * 2, // 100%
                        perspective: '0px',
                        scaleX: 1,
                        scaleY: 1,
                        scaleZ: 1,
                        easing: `cubicBezier(0.42, 0, 1.0, 1.0)`,
                    },
                ],
            };
            return animation;
        },
    },
    {
        nameShown: 'Fade',
        name: 'fade',
        category: 'Appear On Stage',
        directions: [
            {
                name: 'Center',
                value: 'In',
            },
            {
                name: 'Top',
                value: 'InDown',
            },
            {
                name: 'Top Big',
                value: 'InDownBig',
                deprecated: true,
            },
            {
                name: 'Left',
                value: 'InLeft',
            },
            {
                name: 'Left Big',
                value: 'InLeftBig',
                deprecated: true,
            },
            {
                name: 'Right',
                value: 'InRight',
            },
            {
                name: 'Right Big',
                value: 'InRightBig',
                deprecated: true,
            },
            {
                name: 'Bottom',
                value: 'InUp',
            },
            {
                name: 'Bottom Big',
                value: 'InUpBig',
                deprecated: true,
            },
        ],
        animationGenerator: function generateFadeAnimation({ rawDirectionName }) {
            return () => {
                const parsedDirection = rawDirectionName.toLowerCase().split(' ');
                const animation = {
                    opacity: [0, 1],
                    ...(parsedDirection[0] !== 'center' && {
                        [`translate${['left', 'right'].includes(parsedDirection[0]) ? 'X' : 'Y'}`]: [
                            `${['left', 'top'].includes(parsedDirection[0]) ? '-' : ''}${parsedDirection.includes('big') ? '2000px' : '50%'}`,
                            '0%',
                        ],
                    }),
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Pop',
        name: 'pop',
        category: 'Appear On Stage',
        directions: [
            {
                name: 'Top',
                value: '-in-top',
            },
            {
                name: 'Left',
                value: '-in-left',
            },
            {
                name: 'Right',
                value: '-in-right',
            },
            {
                name: 'Bottom',
                value: '-in-bottom',
            },
            {
                name: 'Backward',
                value: '-in-bck',
            },
            {
                name: 'Forward',
                value: '-in-fwd',
            },
        ],
        easingsCompatible: false,
        animationGenerator: function generatePopAnimation({ rawDirectionName }) {
            return () => {
                const parsedDirection = rawDirectionName.toLowerCase().split(' ');
                const animation = {
                    opacity: [0, 1],
                    ...(!['backward', 'forward'].includes(parsedDirection[0]) && {
                        [`translate${['left', 'right'].includes(parsedDirection[0]) ? 'X' : 'Y'}`]: [
                            `${['left', 'top'].includes(parsedDirection[0]) ? '-' : ''}500px`,
                            '0%',
                        ],
                    }),
                    ...(['backward', 'forward'].includes(parsedDirection[0]) && {
                        scale: [parsedDirection[0] === 'backward' ? 7 : 0, 1],
                    }),
                    easing: 'easeOutBounce',
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Turn',
        deprecated: true,
        name: 'rotate',
        category: 'Appear On Stage',
        directions: [
            {
                name: 'Center',
                value: '-in-center',
            },
            {
                name: 'Bottom Left',
                value: '-in-bl',
            },
            {
                name: 'Top',
                value: '-in-top',
            },
            {
                name: 'Bottom',
                value: '-in-bottom',
            },
            {
                name: 'Left',
                value: '-in-left',
            },
            {
                name: 'Right',
                value: '-in-right',
            },
            {
                name: 'Bottom Right',
                value: '-in-br',
            },
            {
                name: 'Top Right',
                value: '-in-tr',
            },
            {
                name: 'Top Left',
                value: '-in-tl',
            },
            {
                name: 'Vertical',
                value: '-in-ver',
            },
            {
                name: 'Horizontal',
                value: '-in-hor',
            },
            {
                name: 'Clockwise',
                value: '-in-2-cw',
            },
            {
                name: 'Forward CCW',
                value: '-in-2-fwd-ccw',
            },
            {
                name: 'Top Right CW',
                value: '-in-2-tr-cw',
            },
            {
                name: 'Bottom Right CCW',
                value: '-in-2-br-ccw',
            },
            {
                name: 'Top Left CW',
                value: '-in-2-tl-cw',
            },
            {
                name: 'CCW',
                value: '-in-2-ccw',
            },
            {
                name: 'Backward CW',
                value: '-in-2-bck-cw',
            },
            {
                name: 'Top Right CCW',
                value: '-in-2-tr-ccw',
            },
            {
                name: 'Bottom Left CW',
                value: '-in-2-bl-cw',
            },
            {
                name: 'Top Left CCW',
                value: '-in-2-tl-ccw',
            },
            {
                name: 'Forward CW',
                value: '-in-2-fwd-cw',
            },
            {
                name: 'Backward CCW',
                value: '-in-2-bck-ccw',
            },
            {
                name: 'Bottom Right CW',
                value: '-in-2-br-cw',
            },
            {
                name: 'Bottom Left CCW',
                value: '-in-2-bl-ccw',
            },
            {
                name: 'Diag 1',
                value: '-in-diag-1',
            },
            {
                name: 'Diag 2',
                value: '-in-diag-2',
            },
        ],
        animationGenerator: function generateTurnAnimation({ rawDirectionName }) {
            return ({ duration }) => {
                const parsedDirection = rawDirectionName.toLowerCase().split(' ');
                const transformOrigin = {
                    x: 50,
                    y: 50,
                };
                let rotate = '+=1turn';
                let rotateY;
                let rotateX;
                let matrix3d;
                let translateZ;
                if (parsedDirection.includes('top'))
                    transformOrigin.y = 0;
                else if (parsedDirection.includes('bottom'))
                    transformOrigin.y = 100;
                if (parsedDirection.includes('left'))
                    transformOrigin.x = 0;
                else if (parsedDirection.includes('right'))
                    transformOrigin.x = 100;
                if (parsedDirection.includes('center'))
                    rotate = '+=1turn';
                if (parsedDirection.includes('horizontal'))
                    rotateX = '+=1turn';
                if (parsedDirection.includes('vertical'))
                    rotateY = '+=1turn';
                if (parsedDirection.includes('clockwise') || parsedDirection.includes('cw'))
                    rotate = [-45, 0];
                if (parsedDirection.includes('ccw'))
                    rotate = rotate = [45, 0];
                if (parsedDirection.includes('backward'))
                    translateZ = ['200px', 0];
                else if (parsedDirection.includes('forward'))
                    translateZ = ['-200px', 0];
                if (parsedDirection.includes('diag')) {
                    switch (parsedDirection[1]) {
                        case '1':
                            matrix3d = [
                                {
                                    value: '1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1',
                                    duration: 0,
                                },
                                {
                                    value: '-2.22045e-16, 1, 0, 0, 1, -2.22045e-16, 0, 0, 0, 0, -1, 0, 0, 0, 0, 1',
                                    duration: duration / 2,
                                },
                                {
                                    value: '1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1',
                                    duration: duration / 2,
                                },
                            ];
                            break;
                        case '2':
                            matrix3d = [
                                {
                                    value: '1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1',
                                    duration: 0,
                                },
                                {
                                    value: '-2.22045e-16, -1, 0, 0, -1, -2.22045e-16, 0, 0, 0, 0, -1, 0, 0, 0, 0, 1',
                                    duration: duration / 2,
                                },
                                {
                                    value: '1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1',
                                    duration: duration / 2,
                                },
                            ];
                            break;
                        default:
                            break;
                    }
                }
                const animation = {
                    transformOrigin: [
                        { duration: 0, value: `${transformOrigin.x}% ${transformOrigin.y}%` },
                        { duration, value: `${transformOrigin.x}% ${transformOrigin.y}%` },
                        { duration: 0, value: `50% 50%` },
                    ],
                    opacity: [0, 1],
                    ...(translateZ && {
                        perspective: [
                            { duration: 0, value: `400px` },
                            { duration, value: `400px` },
                            { duration: 0, value: `0px` },
                        ],
                        translateZ,
                    }),
                    ...(rotate && !rotateX && !rotateY && !matrix3d && { rotate }),
                    ...(rotateX && { rotateX }),
                    ...(rotateY && { rotateY }),
                    ...(matrix3d && { matrix3d }),
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Tilt',
        name: 'tilt',
        category: 'Appear On Stage',
        directions: [
            {
                name: 'Top',
                value: '-in-top-1',
            },
            {
                name: 'Top Reversed',
                value: '-in-top-2',
            },
            {
                name: 'Top Right',
                value: '-in-tr',
                deprecated: true,
            },
            {
                name: 'Right',
                value: '-in-right-1',
            },
            {
                name: 'Right Reversed',
                value: '-in-right-2',
            },
            {
                name: 'Bottom Right',
                value: '-in-br',
                deprecated: true,
            },
            {
                name: 'Bottom',
                value: '-in-bottom-1',
            },
            {
                name: 'Bottom Reversed',
                value: '-in-bottom-2',
            },
            {
                name: 'Bottom Left',
                value: '-in-bl',
                deprecated: true,
            },
            {
                name: 'Left',
                value: '-in-left-1',
            },
            {
                name: 'Left Reversed',
                value: '-in-left-2',
            },
            {
                name: 'Top Left',
                value: '-in-tl',
                deprecated: true,
            },
            {
                name: 'Forward Top Right',
                value: '-in-fwd-tr',
                deprecated: true,
            },
            {
                name: 'Forward Bottom Right',
                value: '-in-fwd-br',
                deprecated: true,
            },
            {
                name: 'Forward Bottom Left',
                value: '-in-fwd-bl',
                deprecated: true,
            },
            {
                name: 'Forward Top Left',
                value: '-in-fwd-tl',
                deprecated: true,
            },
        ],
        animationGenerator: function generateTiltAnimation({ rawDirectionName }) {
            return () => {
                function getOldRawAnimationName(newRawName) {
                    const splitNewRawName = newRawName.split(' ');
                    let oldRawName = '';
                    if (splitNewRawName.length === 3) {
                        // Forward or backward included
                        oldRawName = newRawName;
                    }
                    else if (splitNewRawName.length === 2) {
                        // #2 replaced by reversed, now the opposite
                        oldRawName = newRawName.replace('Reversed', '#2');
                    }
                    else if (splitNewRawName.length === 1) {
                        // #1 removed
                        splitNewRawName.push('#1');
                        oldRawName = splitNewRawName.join(' ');
                    }
                    return oldRawName;
                }
                const oldRawName = getOldRawAnimationName(rawDirectionName);
                const parsedDirection = oldRawName.toLowerCase().split(' ');
                let rotateY, rotateX, translateX, translateY, skewX, skewY;
                if (parsedDirection.includes('#1') || parsedDirection.includes('#2')) {
                    if (parsedDirection.includes('top') || parsedDirection.includes('bottom')) {
                        translateY = [parsedDirection.includes('top') ? -300 : 300, 0];
                        rotateY = [parsedDirection.includes('#1') ? 30 : -30, 0];
                        skewY = [parsedDirection.includes('#1') ? -30 : 30, 0];
                    }
                    else if (parsedDirection.includes('left') || parsedDirection.includes('right')) {
                        translateX = [parsedDirection.includes('left') ? -300 : 300, 0];
                        rotateX = [parsedDirection.includes('#1') ? -30 : 30, 0];
                        skewX = [parsedDirection.includes('#1') ? -30 : 30, 0];
                    }
                }
                else if (parsedDirection.includes('top')) {
                    if (parsedDirection.includes('forward')) {
                        rotateX = [35, 0];
                        rotateY = [parsedDirection.includes('left') ? -20 : 20, 0];
                        translateX = [parsedDirection.includes('left') ? -300 : 300, 0];
                        translateY = [-300, 0];
                        skewX = [parsedDirection.includes('left') ? 35 : -35, 0];
                        skewY = [parsedDirection.includes('left') ? -10 : 10, 0];
                    }
                    else {
                        rotateX = [20, 0];
                        rotateY = [parsedDirection.includes('left') ? 35 : -35, 0];
                        translateX = [parsedDirection.includes('left') ? -250 : 250, 0];
                        translateY = [-250, 0];
                        skewX = [parsedDirection.includes('left') ? 12 : -12, 0];
                        skewY = [parsedDirection.includes('left') ? 15 : -15, 0];
                    }
                }
                else if (parsedDirection.includes('bottom')) {
                    if (parsedDirection.includes('forward')) {
                        rotateX = [-35, 0];
                        rotateY = [parsedDirection.includes('left') ? -20 : 20, 0];
                        translateX = [parsedDirection.includes('left') ? -300 : 300, 0];
                        translateY = [300, 0];
                        skewX = [parsedDirection.includes('left') ? -35 : 35, 0];
                        skewY = [parsedDirection.includes('left') ? 10 : -10, 0];
                    }
                    else {
                        rotateX = [-20, 0];
                        rotateY = [parsedDirection.includes('left') ? 35 : -35, 0];
                        translateX = [parsedDirection.includes('left') ? -250 : 250, 0];
                        translateY = [250, 0];
                        skewX = [parsedDirection.includes('left') ? -12 : 12, 0];
                        skewY = [parsedDirection.includes('left') ? -15 : 15, 0];
                    }
                }
                const animation = {
                    opacity: [0, 1],
                    ...(rotateX && { rotateX }),
                    ...(rotateY && { rotateY }),
                    ...(translateX && { translateX }),
                    ...(translateY && { translateY }),
                    ...(skewX && { skewX }),
                    ...(skewY && { skewY }),
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Grow',
        name: 'scale',
        category: 'Appear On Stage',
        directions: [
            {
                name: 'Center',
                value: '-in-center',
            },
            {
                name: 'Top',
                value: '-in-top',
            },
            { name: 'Top Right', value: '-in-tr' },
            { name: 'Right', value: '-in-right' },
            { name: 'Bottom Right', value: '-in-br' },
            { name: 'Bottom', value: '-in-bottom' },
            { name: 'Bottom Left', value: '-in-bl' },
            { name: 'Left', value: '-in-left' },
            { name: 'Top Left', value: '-in-tl' },
        ],
        animationGenerator: function generateGrowAnimation({ rawDirectionName }) {
            return ({ duration }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                const direction = {};
                if (!directionComponents[1]) {
                    direction.x = ['left', 'right'].includes(directionComponents[0].toLowerCase())
                        ? directionComponents[0].toLowerCase()
                        : 'center';
                    direction.y = ['top', 'bottom'].includes(directionComponents[0].toLowerCase())
                        ? directionComponents[0].toLowerCase()
                        : 'center';
                }
                else {
                    ;
                    [direction.y, direction.x] = directionComponents;
                }
                const transformOrigin = {};
                const translate = {};
                switch (direction.x) {
                    case 'left':
                        transformOrigin.x = 0;
                        translate.x = 0;
                        break;
                    case 'right':
                        transformOrigin.x = 100;
                        translate.x = 0;
                        break;
                    case 'center':
                        transformOrigin.x = 50;
                        translate.x = 0;
                        break;
                    default:
                        break;
                }
                switch (direction.y) {
                    case 'top':
                        transformOrigin.y = 0;
                        translate.y = 0;
                        break;
                    case 'bottom':
                        transformOrigin.y = 100;
                        translate.y = 0;
                        break;
                    case 'center':
                        transformOrigin.y = 50;
                        translate.y = 0;
                        break;
                    default:
                        break;
                }
                const keyframeAnimation = {
                    scaleX: [0, 1],
                    scaleY: [0, 1],
                    opacity: [0, 1],
                    keyframes: [
                        {
                            transformOrigin: `${transformOrigin.x}% ${transformOrigin.y}%`,
                            translateX: `${translate.x}%`,
                            translateY: `${translate.y}%`,
                            duration: 0,
                        },
                        {
                            duration,
                        },
                        {
                            transformOrigin: '50% 50%',
                            translateX: `0%`,
                            translateY: `0%`,
                            duration: 0,
                        },
                    ],
                };
                return keyframeAnimation;
            };
        },
    },
    {
        nameShown: 'Expand',
        name: 'expand',
        category: 'Appear On Stage',
        directions: [
            { name: 'Horizontal Center', value: '-in-hor-center' },
            { name: 'Horizontal Left', value: '-in-hor-left' },
            { name: 'Horizontal Right', value: '-in-hor-right' },
            { name: 'Vertical Center', value: '-in-ver-center' },
            { name: 'Vertical Top', value: '-in-ver-top' },
            { name: 'Vertical Bottom', value: '-in-ver-bottom' },
        ],
        animationGenerator: function generateExpandAnimation({ rawDirectionName }) {
            return ({ duration }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                const translate = { x: 0, y: 0 };
                const scale = { x: 1, y: 1 };
                const transformOrigin = {};
                switch (directionComponents[0]) {
                    case 'horizontal':
                        scale.x = 0;
                        scale.y = 1;
                        transformOrigin.y = 50;
                        switch (directionComponents[1]) {
                            case 'left':
                                transformOrigin.x = 0;
                                translate.x = 0;
                                break;
                            case 'right':
                                transformOrigin.x = 100;
                                translate.x = 0;
                                break;
                            case 'center':
                                transformOrigin.x = 50;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 'vertical':
                        scale.x = 1;
                        scale.y = 0;
                        transformOrigin.x = 50;
                        switch (directionComponents[1]) {
                            case 'top':
                                transformOrigin.y = 0;
                                translate.y = 0;
                                break;
                            case 'bottom':
                                transformOrigin.y = 100;
                                translate.y = 0;
                                break;
                            case 'center':
                                transformOrigin.x = 50;
                                break;
                            default:
                                break;
                        }
                        break;
                    default:
                        break;
                }
                const keyframeAnimation = {
                    keyframes: [
                        {
                            transformOrigin: `${transformOrigin.x}% ${transformOrigin.y}%`,
                            translateX: `${translate.x}%`,
                            translateY: `${translate.y}%`,
                            duration: 0,
                            scaleX: `${scale.x}`,
                            scaleY: `${scale.y}`,
                        },
                        {
                            scaleX: 1,
                            scaleY: 1,
                            duration,
                        },
                        {
                            transformOrigin: '50% 50%',
                            translateX: `0%`,
                            translateY: `0%`,
                            duration: 0,
                        },
                    ],
                };
                return keyframeAnimation;
            };
        },
    },
    {
        nameShown: 'Twirl',
        deprecated: true,
        name: 'swirl',
        category: 'Appear On Stage',
        directions: [
            { name: 'Forward', value: '-in-fwd' },
            { name: 'Backward', value: '-in-bck' },
            { name: 'Top Forward', value: '-in-top-fwd' },
            { name: 'Top Backward', value: '-in-top-bck' },
            { name: 'Top Right Forward', value: '-in-tr-fwd' },
            { name: 'Top Right Backward', value: '-in-tr-bck' },
            { name: 'Right Forward', value: '-in-right-fwd' },
            { name: 'Right Backward', value: '-in-right-bck' },
            { name: 'Bottom Right Forward', value: '-in-br-fwd' },
            { name: 'Bottom Right Backward', value: '-in-br-bck' },
            { name: 'Bottom Forward', value: '-in-bottom-fwd' },
            { name: 'Bottom Backward', value: '-in-bottom-bck' },
            { name: 'Bottom Left Forward', value: '-in-bl-fwd' },
            { name: 'Bottom Left Backward', value: '-in-bl-bck' },
            { name: 'Left Forward', value: '-in-left-fwd' },
            { name: 'Left Backward', value: '-in-left-bck' },
            { name: 'Top Left Forward', value: '-in-tl-fwd' },
            { name: 'Top Left Backward', value: '-in-tl-bck' },
        ],
        animationGenerator: function generateTwirlAnimation({ rawDirectionName }) {
            return ({ element, duration }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                let forward, left, top;
                switch (directionComponents.length) {
                    case 3:
                        forward = directionComponents[2];
                        left = directionComponents[1];
                        top = directionComponents[0];
                        break;
                    case 2:
                        forward = directionComponents[1];
                        left = ['left', 'right'].includes(directionComponents[0]) ? directionComponents[0] : 'center';
                        top = ['top', 'bottom'].includes(directionComponents[0]) ? directionComponents[0] : 'center';
                        break;
                    case 1:
                        forward = directionComponents[0];
                        break;
                    default:
                        break;
                }
                const rotate = `${-540 * (forward === 'forward' ? 1 : forward === 'backward' ? -1 : 0)}deg`;
                const scale = {
                    x: forward === 'forward' ? 0 : forward === 'backward' ? 5 : 0,
                    y: forward === 'forward' ? 0 : forward === 'backward' ? 5 : 0,
                };
                const transformOrigin = {};
                const translate = {};
                switch (top) {
                    case 'top':
                        transformOrigin.y = 0;
                        translate.y = 0;
                        break;
                    case 'bottom':
                        transformOrigin.y = 1;
                        translate.y = 0;
                        break;
                    case 'center':
                    default:
                        transformOrigin.y = 50;
                        translate.y = 0;
                        break;
                }
                switch (left) {
                    case 'left':
                        transformOrigin.x = 0;
                        translate.x = 0;
                        break;
                    case 'right':
                        transformOrigin.x = 100;
                        translate.x = 0;
                        break;
                    case 'center':
                    default:
                        transformOrigin.x = 50;
                        translate.x = 0;
                        break;
                }
                const keyframeAnimation = {
                    keyframes: [
                        {
                            transformOrigin: `${transformOrigin.x}% ${transformOrigin.y}%`,
                            duration: 0,
                            translateX: `${translate.x}%`,
                            translateY: `${translate.y}%`,
                            scaleX: `${scale.x}`,
                            scaleY: `${scale.y}`,
                            opacity: 0,
                        },
                        {
                            rotate,
                            duration: 0,
                        },
                        {
                            rotate: 0,
                            scaleX: 1,
                            scaleY: 1,
                            translateX: `${translate.x}%`,
                            translateY: `${translate.y}%`,
                            opacity: 1,
                            duration,
                        },
                        {
                            transformOrigin: '50% 50%',
                            translateX: `0%`,
                            translateY: `0%`,
                            duration: 0,
                        },
                    ],
                };
                return keyframeAnimation;
            };
        },
    },
    {
        nameShown: 'Swing',
        name: 'flip',
        category: 'Appear On Stage',
        directions: [
            { name: 'Horizontal', value: '-in-hor-bottom' },
            { name: 'Horizontal Top', value: '-in-hor-top', deprecated: true },
            { name: 'Vertical', value: '-in-ver-right' },
            { name: 'Vertical Left', value: '-in-ver-left', deprecated: true },
            { name: 'Diagonal', value: '-in-diag-1-tr' },
            { name: 'Diagonal #1 Bottom Left', value: '-in-diag-1-bl', deprecated: true },
            { name: 'Diagonal Reversed', value: '-in-diag-2-tl' },
            { name: 'Diagonal #2 Bottom Right', value: '-in-diag-2-br', deprecated: true },
        ],
        animationGenerator: function generateSwingAnimation({ rawDirectionName }) {
            return ({ element, duration }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                let rotateX, rotateY, matrix3d;
                if (directionComponents.includes('horizontal')) {
                    // switch (directionComponents[0]) {
                    //   case 'bottom':
                    //     rotateX = -80
                    //     break
                    //   case 'top':
                    //     rotateX = 80
                    //     break
                    //   default:
                    //     break
                    // }
                    // Case Horizontal Bottom preserved
                    rotateX = -80;
                }
                else if (directionComponents.includes('vertical')) {
                    // switch (directionComponents[0]) {
                    //   case 'right':
                    //     rotateY = -80
                    //     break
                    //   case 'left':
                    //     rotateY = 80
                    //     break
                    //   default:
                    //     break
                    // }
                    // Case Horizontal Bottom preserved
                    rotateY = -80;
                }
                else if (directionComponents.includes('diagonal')) {
                    switch (directionComponents[1]) {
                        case undefined:
                            // Other previous variations were deprecated
                            // if (directionComponents[2] === 'top' && directionComponents[3] === 'right') {
                            //   matrix3d = [
                            //     // rotate3d(1, 1, 0, -80deg);
                            //     '0.586824, 0.413176, -0.696364, 0, 0.413176, 0.586824, 0.696364, 0, 0.696364, -0.696364, 0.173648, 0, 0, 0, 0, 1',
                            //     INITIAL_MATRIX_3D,
                            //   ]
                            // } else if (directionComponents[2] === 'bottom' && directionComponents[3] === 'left') {
                            //   // rotate3d(1, 1, 0, 80deg);
                            //   matrix3d = [
                            //     '0.586824, 0.413176, 0.696364, 0, 0.413176, 0.586824, -0.696364, 0, -0.696364, 0.696364, 0.173648, 0, 0, 0, 0, 1',
                            //     INITIAL_MATRIX_3D,
                            //   ]
                            // }
                            // Case #1 Top Right was preserved
                            matrix3d = [
                                // rotate3d(1, 1, 0, -80deg);
                                '0.586824, 0.413176, -0.696364, 0, 0.413176, 0.586824, 0.696364, 0, 0.696364, -0.696364, 0.173648, 0, 0, 0, 0, 1',
                                INITIAL_MATRIX_3D,
                            ];
                            break;
                        case 'reversed':
                            // Other previous variations were deprecated
                            // if (directionComponents[2] === 'top' && directionComponents[3] === 'left') {
                            //   matrix3d = [
                            //     // rotate3d(-1, 1, 0, -80deg);
                            //     '0.586824, -0.413176, 0.696364, 0, -0.413176, 0.586824, 0.696364, 0, -0.696364, -0.696364, 0.173648, 0, 0, 0, 0, 1',
                            //     INITIAL_MATRIX_3D,
                            //   ]
                            // } else if (directionComponents[2] === 'bottom' && directionComponents[3] === 'right') {
                            //   matrix3d = [
                            //     // rotate3d(-1, 1, 0, 80deg);
                            //     '0.586824, -0.413176, -0.696364, 0, -0.413176, 0.586824, -0.696364, 0, 0.696364, 0.696364, 0.173648, 0, 0, 0, 0, 1',
                            //     INITIAL_MATRIX_3D,
                            //   ]
                            // }
                            // Case #2 Top Left was preserved
                            matrix3d = [
                                // rotate3d(-1, 1, 0, -80deg);
                                '0.586824, -0.413176, 0.696364, 0, -0.413176, 0.586824, 0.696364, 0, -0.696364, -0.696364, 0.173648, 0, 0, 0, 0, 1',
                                INITIAL_MATRIX_3D,
                            ];
                            break;
                        default:
                            break;
                    }
                }
                const keyframeAnimation = {
                    keyframes: [
                        {
                            opacity: 0,
                            perspective: '1000px',
                            ...(rotateX && { rotateX }),
                            ...(rotateY && { rotateY }),
                            ...(matrix3d && { matrix3d: matrix3d[0] }),
                            duration: 0,
                        },
                        {
                            opacity: 1,
                            perspective: '1000px',
                            ...(rotateX && { rotateX: 0 }),
                            ...(rotateY && { rotateY: 0 }),
                            ...(matrix3d && { matrix3d: matrix3d[1] }),
                            duration,
                        },
                        {
                            perspective: '0px',
                            duration: 0,
                        },
                    ],
                };
                return keyframeAnimation;
            };
        },
    },
    {
        nameShown: 'Slide',
        name: 'slide',
        category: 'Appear On Stage',
        directions: [
            { name: 'Top', value: '-in-top' },
            { name: 'Top Right', value: '-in-tr', deprecated: true },
            { name: 'Right', value: '-in-right' },
            { name: 'Bottom Right', value: '-in-br', deprecated: true },
            { name: 'Bottom', value: '-in-bottom' },
            { name: 'Bottom Left', value: '-in-bl', deprecated: true },
            { name: 'Left', value: '-in-left' },
            { name: 'Top Left', value: '-in-tl', deprecated: true },
            { name: 'Forward Center', value: '-in-fwd-center' },
            { name: 'Forward Top', value: '-in-fwd-top' },
            { name: 'Forward Top Right', value: '-in-fwd-tr', deprecated: true },
            { name: 'Forward Right', value: '-in-fwd-right' },
            { name: 'Forward Bottom Right', value: '-in-fwd-br', deprecated: true },
            { name: 'Forward Bottom', value: '-in-fwd-bottom' },
            { name: 'Forward Bottom Left', value: '-in-fwd-bl', deprecated: true },
            { name: 'Forward Left', value: '-in-fwd-left' },
            { name: 'Forward Top Left', value: '-in-fwd-tl', deprecated: true },
            { name: 'Backward Center', value: '-in-bck-center' },
            { name: 'Backward Top', value: '-in-bck-top' },
            { name: 'Backward Top Right', value: '-in-bck-tr', deprecated: true },
            { name: 'Backward Right', value: '-in-bck-right' },
            { name: 'Backward Bottom Right', value: '-in-bck-br', deprecated: true },
            { name: 'Backward Bottom', value: '-in-bck-bottom' },
            { name: 'Backward Bottom Left', value: '-in-bck-bl', deprecated: true },
            { name: 'Backward Left', value: '-in-bck-left' },
            { name: 'Backward Top Left', value: '-in-bck-tl', deprecated: true },
        ],
        animationGenerator: function generateSlideAnimation({ rawDirectionName }) {
            return ({ duration, element, contentHeight, contentWidth, }) => {
                let translateY, translateX, translateZ;
                const perspective = 300;
                const translateZValue = perspective / 2;
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                if (directionComponents.includes('top')) {
                    translateY = [
                        ['forward', 'backward'].includes(directionComponents[0]) ? -800 : -element.y - element.height,
                        0,
                    ];
                }
                else if (directionComponents.includes('bottom')) {
                    translateY = [['forward', 'backward'].includes(directionComponents[0]) ? 800 : contentHeight - element.y, 0];
                }
                if (directionComponents.includes('left')) {
                    translateX = [-element.x - element.width, 0];
                }
                else if (directionComponents.includes('right')) {
                    translateX = [contentWidth - element.x, 0];
                }
                if (directionComponents.includes('forward')) {
                    translateZ = [translateZValue * -4, 0];
                }
                else if (directionComponents.includes('backward')) {
                    translateZ = [translateZValue, 0];
                }
                const animation = {
                    opacity: [0, 1],
                    ...(translateX && { translateX }),
                    ...(translateY && { translateY }),
                    ...(translateZ && {
                        perspective: [
                            { duration: 0, value: `${perspective}px` },
                            { duration, value: `${perspective}px` },
                            { duration: 0, value: `0px` },
                        ],
                        translateZ,
                    }),
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Blade',
        deprecated: true,
        name: 'slit',
        category: 'Appear On Stage',
        directions: [
            { name: 'Vertical', value: '-in-vertical' },
            { name: 'Horizontal', value: '-in-horizontal' },
            { name: 'Diagonal #1', value: '-in-diagonal-1' },
            { name: 'Diagonal #2', value: '-in-diagonal-2' },
        ],
        animationGenerator: function generateBladeAnimation({ rawDirectionName }) {
            return ({ duration }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                let keyframes;
                if (directionComponents.includes('horizontal')) {
                    keyframes = [
                        {
                            translateZ: -800,
                            rotateX: 90,
                            opacity: 0,
                            duration: 0,
                        },
                        {
                            translateZ: -160,
                            rotateX: 87,
                            opacity: 1,
                            duration: duration * 0.54,
                        },
                        {
                            translateZ: 0,
                            rotateX: 0,
                            duration: duration * (1 - 0.54),
                        },
                    ];
                }
                else if (directionComponents.includes('vertical')) {
                    keyframes = [
                        {
                            translateZ: -800,
                            rotateY: 90,
                            opacity: 0,
                            duration: 0,
                        },
                        {
                            translateZ: -160,
                            rotateY: 87,
                            opacity: 1,
                            duration: duration * 0.54,
                        },
                        {
                            translateZ: 0,
                            rotateY: 0,
                            duration: duration * (1 - 0.54),
                        },
                    ];
                }
                else if (directionComponents.includes('diagonal')) {
                    switch (directionComponents[1]) {
                        case '#1':
                            keyframes = [
                                {
                                    translateZ: -800,
                                    matrix3d: '0.5, 0.5, -0.707107, 0, 0.5, 0.5, 0.707107, 0, 0.707107, -0.707107, 0, 0, 0, 0, 0, 1',
                                    opacity: 0,
                                    duration: 0,
                                },
                                {
                                    translateZ: -160,
                                    matrix3d: '0.526168, 0.473832, -0.706138, 0, 0.473832, 0.526168, 0.706138, 0, 0.706138, -0.706138, 0.052336, 0, 0, 0, 0, 1',
                                    opacity: 1,
                                    duration: duration * 0.54,
                                },
                                {
                                    translateZ: 0,
                                    matrix3d: INITIAL_MATRIX_3D,
                                    duration: duration * (1 - 0.54),
                                },
                            ];
                            break;
                        case '#2':
                            keyframes = [
                                {
                                    translateZ: -800,
                                    matrix3d: '0.5, -0.5, 0.707107, 0, -0.5, 0.5, 0.707107, 0, -0.707107, -0.707107, 0, 0, 0, 0, 0, 1',
                                    opacity: 0,
                                    duration: 0,
                                },
                                {
                                    translateZ: -160,
                                    matrix3d: '0.526168, -0.473832, 0.706138, 0, -0.473832, 0.526168, 0.706138, 0, -0.706138, -0.706138, 0.052336, 0, 0, 0, 0, 1',
                                    opacity: 1,
                                    duration: duration * 0.54,
                                },
                                {
                                    translateZ: 0,
                                    matrix3d: INITIAL_MATRIX_3D,
                                    duration: duration * (1 - 0.54),
                                },
                            ];
                            break;
                        default:
                            break;
                    }
                }
                const keyframeAnimation = {
                    keyframes,
                };
                return keyframeAnimation;
            };
        },
    },
    {
        nameShown: 'Vaporize',
        name: 'blurred-slide',
        category: 'Appear On Stage',
        directions: [
            { name: 'Top', value: '-in-top' },
            { name: 'Top Right', value: '-in-tr', deprecated: true },
            { name: 'Right', value: '-in-right' },
            { name: 'Bottom Right', value: '-in-br', deprecated: true },
            { name: 'Bottom', value: '-in-bottom' },
            { name: 'Bottom Left', value: '-in-bl', deprecated: true },
            { name: 'Left', value: '-in-left' },
            { name: 'Top Left', value: '-in-tl', deprecated: true },
        ],
        animationGenerator: function generateVaporizeAnimation({ rawDirectionName }) {
            return ({ duration, element }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                let transformOrigin = '50% 50%';
                let translateX;
                let translateY;
                let skewX;
                let skewY;
                let scaleX;
                let scaleY;
                const translateXValue = element.width;
                const translateYValue = element.height;
                const skewXValue = 80;
                let shouldRevertX, shouldRevertY;
                switch (directionComponents.length) {
                    case 1:
                        transformOrigin = `${['top', 'bottom'].includes(directionComponents[0]) ? (directionComponents[0] === 'top' ? 0 : 100) : 50}% ${['left', 'right'].includes(directionComponents[0]) ? (directionComponents[0] === 'top' ? 0 : 100) : 50}%`;
                        translateX = ['left', 'right'].includes(directionComponents[0])
                            ? [-translateXValue * (directionComponents[0] === 'left' ? 1 : -1), 0]
                            : undefined;
                        translateY = ['top', 'bottom'].includes(directionComponents[0])
                            ? [-translateYValue * (directionComponents[0] === 'top' ? 1 : -1), 0]
                            : undefined;
                        scaleX = [['left', 'right'].includes(directionComponents[0]) ? 2.5 : 0.5, 1];
                        scaleY = [['top', 'bottom'].includes(directionComponents[0]) ? 2.5 : 0.5, 1];
                        break;
                    case 2:
                        transformOrigin = `${directionComponents[0] === 'top' ? 0 : 100}% ${directionComponents[0] === 'left' ? 0 : 100}%`;
                        shouldRevertX = directionComponents[1] === 'left';
                        shouldRevertY = directionComponents[0] === 'top';
                        translateX = [-translateXValue * (shouldRevertX ? 1 : -1), 0];
                        translateY = [-translateYValue * (shouldRevertY ? 1 : -1), 0];
                        skewX = [-skewXValue * (shouldRevertX ? 1 : -1), 0];
                        skewY = [-10 * (shouldRevertY ? 1 : -1), 0];
                        break;
                    default:
                        break;
                }
                const animation = {
                    opacity: [0, 1],
                    filter: ['blur(80px)', 'blur(0px)'],
                    ...(translateX && { translateX }),
                    ...(translateY && { translateY }),
                    ...(skewX && { skewX }),
                    ...(skewY && { skewY }),
                    ...(scaleX && { scaleX }),
                    ...(scaleY && { scaleY }),
                    transformOrigin: [
                        {
                            value: '50% 50%',
                            duration: 0,
                        },
                        {
                            value: transformOrigin,
                            duration,
                        },
                        {
                            value: '50% 50%',
                            duration: 0,
                        },
                    ],
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Scoop',
        name: 'elliptic-slide',
        category: 'Appear On Stage',
        directions: [
            { name: 'Top Forward', value: '-in-top-fwd' },
            { name: 'Top Backward', value: '-in-top-bck' },
            { name: 'Right Forward', value: '-in-right-fwd' },
            { name: 'Right Backward', value: '-in-right-bck' },
            { name: 'Bottom Forward', value: '-in-bottom-fwd' },
            { name: 'Bottom Backward', value: '-in-bottom-bck' },
            { name: 'Left Forward', value: '-in-left-fwd' },
            { name: 'Left Backward', value: '-in-left-bck' },
        ],
        animationGenerator: function generateScoopAnimation({ rawDirectionName }) {
            return ({ duration }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                let translateX, translateY, rotateX, rotateY, scale, transformOrigin;
                if (['top', 'bottom'].includes(directionComponents[0])) {
                    const shouldRevert = directionComponents[0] === 'top';
                    const translateYValue = 600 * (1 / 4);
                    const rotateXValue = 30;
                    if (directionComponents[1] === 'forward') {
                        translateY = [shouldRevert ? -translateYValue : translateYValue, 0];
                        rotateX = [shouldRevert ? -rotateXValue : rotateXValue, 0];
                        scale = [0, 1];
                        transformOrigin = [
                            { value: '50% 100%', duration: 0 },
                            { value: `50% ${1400 * (shouldRevert ? 1 : -1)}px`, duration },
                        ];
                    }
                    else if (directionComponents[1] === 'backward') {
                        translateY = [shouldRevert ? -translateYValue : translateYValue, 0];
                        rotateX = [shouldRevert ? rotateXValue : -rotateXValue, 0];
                        scale = [6.5 * (2 / 4), 1];
                        transformOrigin = [
                            {
                                value: `50% ${shouldRevert ? 200 : -100}%`,
                                duration: 0,
                            },
                            { value: `50% ${-500 * (shouldRevert ? 1 : -1)}px`, duration },
                        ];
                    }
                }
                else if (['left', 'right'].includes(directionComponents[0])) {
                    const shouldRevert = directionComponents[0] === 'left';
                    const translateXValue = 800 * (1 / 4);
                    const rotateYValue = 30;
                    if (directionComponents[1] === 'forward') {
                        translateX = [shouldRevert ? -translateXValue : translateXValue, 0];
                        rotateY = [shouldRevert ? rotateYValue : -rotateYValue, 0];
                        scale = [0, 1];
                        transformOrigin = [
                            { value: '-100% 50%', duration: 0 },
                            { value: `${1800 * (shouldRevert ? 1 : -1)}px 50% `, duration },
                        ];
                    }
                    else if (directionComponents[1] === 'backward') {
                        translateX = [shouldRevert ? -translateXValue : translateXValue, 0];
                        rotateX = [shouldRevert ? -rotateYValue : rotateYValue, 0];
                        scale = [6.5 * (2 / 4), 1];
                        transformOrigin = [
                            { value: `${shouldRevert ? 200 : -100}% 50%`, duration: 0 },
                            { value: `${-600 * (shouldRevert ? 1 : -1)}px 50% `, duration },
                        ];
                    }
                }
                const animation = {
                    opacity: [0, 1],
                    ...(translateX && { translateX }),
                    ...(translateY && { translateY }),
                    ...(rotateX && { rotateX }),
                    ...(rotateY && { rotateY }),
                    ...(scale && { scale }),
                    ...(transformOrigin && {
                        transformOrigin: [
                            ...transformOrigin,
                            {
                                value: '50% 50%',
                                duration: 0,
                            },
                        ],
                    }),
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Dribble',
        name: 'bounce',
        category: 'Appear On Stage',
        easingsCompatible: false,
        directions: [
            { name: 'Top', value: 'InUp' },
            { name: 'Right', value: 'InRight' },
            { name: 'Bottom', value: 'InDown' },
            { name: 'Left', value: 'InLeft' },
        ],
        animationGenerator: function generateDribbleAnimation({ rawDirectionName }) {
            return ({ duration, element }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                const shouldInvert = ['bottom', 'right'].includes(directionComponents[0]);
                const originalValues = [-3000, 20, -10, 5, 0];
                const max = Math.max(...originalValues.map((originalValue) => Math.abs(originalValue)));
                const ratios = originalValues.map((originalValue) => originalValue / max);
                const maxDistance = ['top', 'bottom'].includes(directionComponents[0])
                    ? element.y + element.height
                    : element.x + element.width;
                const animation = {
                    opacity: [0, 1],
                    keyframes: [
                        {
                            duration: 0,
                            [`translate${['top', 'bottom'].includes(directionComponents[0]) ? 'Y' : 'X'}`]: ratios[0] * maxDistance * (shouldInvert ? -1 : 1),
                        },
                        {
                            duration: duration * 0.6,
                            [`translate${['top', 'bottom'].includes(directionComponents[0]) ? 'Y' : 'X'}`]: ratios[1] * maxDistance * (shouldInvert ? -1 : 1),
                        },
                        {
                            duration: duration * 0.15,
                            [`translate${['top', 'bottom'].includes(directionComponents[0]) ? 'Y' : 'X'}`]: ratios[2] * maxDistance * (shouldInvert ? -1 : 1),
                        },
                        {
                            duration: duration * 0.15,
                            [`translate${['top', 'bottom'].includes(directionComponents[0]) ? 'Y' : 'X'}`]: ratios[3] * maxDistance * (shouldInvert ? -1 : 1),
                        },
                        {
                            duration: duration * 0.1,
                            [`translate${['top', 'bottom'].includes(directionComponents[0]) ? 'Y' : 'X'}`]: ratios[4] * maxDistance * (shouldInvert ? -1 : 1),
                        },
                    ],
                    easing: 'cubicBezier(0.215, 0.610, 0.355, 1.000)',
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Roll',
        deprecated: true,
        name: 'roll',
        category: 'Appear On Stage',
        directions: [
            { name: 'Top', value: '-in-top' },
            { name: 'Right', value: '-in-right' },
            { name: 'Bottom', value: '-in-bottom' },
            { name: 'Left', value: '-in-left' },
            { name: 'Blurred Top', value: '-in-blurred-top' },
            { name: 'Blurred Right', value: '-in-blurred-right' },
            { name: 'Blurred Bottom', value: '-in-blurred-bottom' },
            { name: 'Blurred Left', value: '-in-blurred-left' },
        ],
        animationGenerator: function generateRollAnimation({ rawDirectionName }) {
            return () => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                const blurred = directionComponents.includes('blurred');
                const origin = blurred ? directionComponents[1] : directionComponents[0];
                const shouldInvert = ['bottom', 'right'].includes(origin);
                const animation = {
                    filter: directionComponents.includes('blurred') ? ['blur(50px)', 'blur(0px)'] : undefined,
                    [`translate${['top', 'bottom'].includes(origin) ? 'Y' : 'X'}`]: [-800 * (shouldInvert ? -1 : 1), 0],
                    opacity: [0, 1],
                    rotate: ['-540deg', 0],
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Hinge',
        name: 'swing',
        category: 'Appear On Stage',
        directions: [
            { name: 'Top Forward', value: '-in-top-fwd' },
            { name: 'Top Backward', value: '-in-top-bck' },
            { name: 'Right Forward', value: '-in-right-fwd' },
            { name: 'Right Backward', value: '-in-right-bck' },
            { name: 'Bottom Forward', value: '-in-bottom-fwd' },
            { name: 'Bottom Backward', value: '-in-bottom-bck' },
            { name: 'Left Forward', value: '-in-left-fwd' },
            { name: 'Left Backward', value: '-in-left-bck' },
        ],
        animationGenerator: function generateHingeAnimation({ rawDirectionName }) {
            return ({ duration }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                let rotateX, rotateY, transformOrigin;
                const perspective = 1000;
                if (['top', 'bottom'].includes(directionComponents[0])) {
                    const shouldRevert = directionComponents[0] === 'top';
                    if (directionComponents[1] === 'forward') {
                        rotateX = [shouldRevert ? -100 : 100, 0];
                        transformOrigin = [
                            { value: `50% ${shouldRevert ? 0 : 100}%`, duration: 0 },
                            { value: `50% ${shouldRevert ? 0 : 100}%`, duration },
                        ];
                    }
                    else if (directionComponents[1] === 'backward') {
                        rotateX = [shouldRevert ? 70 : -70, 0];
                        transformOrigin = [
                            { value: `50% ${shouldRevert ? 0 : 100}%`, duration: 0 },
                            { value: `50% ${shouldRevert ? 0 : 100}%`, duration },
                        ];
                    }
                }
                else if (['left', 'right'].includes(directionComponents[0])) {
                    const shouldRevert = directionComponents[0] === 'left';
                    if (directionComponents[1] === 'forward') {
                        rotateY = [shouldRevert ? 100 : -100, 0];
                        transformOrigin = [
                            { value: `${shouldRevert ? 0 : 100}% 50%`, duration: 0 },
                            { value: `${shouldRevert ? 0 : 100}% 50% `, duration },
                        ];
                    }
                    else if (directionComponents[1] === 'backward') {
                        rotateY = [shouldRevert ? -70 : 70, 0];
                        transformOrigin = [
                            { value: `${shouldRevert ? 0 : 100}% 50%`, duration: 0 },
                            { value: `${shouldRevert ? 0 : 100}% 50% `, duration },
                        ];
                    }
                }
                const animation = {
                    opacity: [0, 1],
                    perspective: [
                        { value: `${perspective}px`, duration: 0 },
                        { value: `${perspective}px`, duration },
                        { value: `0px`, duration: 0 },
                    ],
                    ...(rotateX && { rotateX }),
                    ...(rotateY && { rotateY }),
                    ...(transformOrigin && {
                        transformOrigin: [
                            ...transformOrigin,
                            {
                                value: '50% 50%',
                                duration: 0,
                            },
                        ],
                    }),
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Land',
        name: 'puff',
        category: 'Appear On Stage',
        directions: [
            { name: 'Center', value: '-in-center' },
            { name: 'Bottom', value: '-in-top' },
            { name: 'Bottom Left', value: '-in-tr', deprecated: true },
            { name: 'Left', value: '-in-right' },
            { name: 'Top Left', value: '-in-br', deprecated: true },
            { name: 'Top', value: '-in-bottom' },
            { name: 'Top Right', value: 'bl', deprecated: true },
            { name: 'Right', value: '-in-left' },
            { name: 'Bottom Right', value: '-in-tl', deprecated: true },
            { name: 'Horizontal', value: '-in-hor' },
            { name: 'Vertical', value: '-in-ver' },
        ],
        animationGenerator: function generateLandAnimation({ rawDirectionName }) {
            return ({ duration, DOMAnimationElement }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                const scaleValue = 4 * (2 / 3);
                let scale = [scaleValue, 1];
                let transformOrigin;
                let scaleX;
                let scaleY;
                switch (directionComponents.length) {
                    case 1:
                        switch (directionComponents[0]) {
                            case 'center':
                                break;
                            case 'top':
                                transformOrigin = [
                                    { value: '50% 0%', duration: 0 },
                                    { value: '50% 0%', duration },
                                ];
                                break;
                            case 'bottom':
                                transformOrigin = [
                                    { value: '50% 100%', duration: 0 },
                                    { value: '50% 100%', duration },
                                ];
                                break;
                            case 'left':
                                transformOrigin = [
                                    { value: '0% 50%', duration: 0 },
                                    { value: '0% 50%', duration },
                                ];
                                break;
                            case 'right':
                                transformOrigin = [
                                    { value: '100% 50%', duration: 0 },
                                    { value: '100% 50%', duration },
                                ];
                                break;
                            case 'vertical':
                                scale = undefined;
                                scaleY = [scaleValue, 1];
                                break;
                            case 'horizontal':
                                scale = undefined;
                                scaleX = [scaleValue, 1];
                                break;
                            default:
                                break;
                        }
                        break;
                    case 2:
                        transformOrigin = [
                            {
                                value: `${directionComponents[1] === 'left' ? 0 : 100}% ${directionComponents[0] === 'top' ? 0 : 100}%`,
                                duration: 0,
                            },
                            {
                                value: `${directionComponents[1] === 'left' ? 0 : 100}% ${directionComponents[0] === 'top' ? 0 : 100}%`,
                                duration,
                            },
                        ];
                        break;
                    default:
                        break;
                }
                const enableBlurOniOS = true;
                const animation = {
                    opacity: [0, 1],
                    ...((!isIOS() || enableBlurOniOS) && {
                        filter: ['blur(4px)', 'blur(0px)'],
                    }),
                    ...(scale && { scale }),
                    ...(scaleX && { scaleX }),
                    ...(scaleY && { scaleY }),
                    ...(transformOrigin && {
                        transformOrigin: [
                            ...transformOrigin,
                            {
                                value: '50% 50%',
                                duration: 0,
                            },
                        ],
                    }),
                    begin: () => {
                        DOMAnimationElement.style.willChange = 'filter, transformOrigin, scale';
                    },
                    complete: () => {
                        DOMAnimationElement.style.willChange = 'auto';
                    },
                };
                return animation;
            };
        },
    },
    // {
    //   nameShown: "Infinite Rotate",
    //   name: "infiniteRotate",
    //   category: "Appear On Stage",
    //   directions: [
    //     { name: "Clockwise", value: "-in-right" },
    //     { name: "Anticlockwise", value: "-in-left" },
    //   ],
    // },
    {
        nameShown: 'Fall',
        deprecated: true,
        name: 'hinge',
        category: 'Appear On Stage',
        animationGenerator: function generateFallAnimation() {
            return ({ duration }) => {
                const animation = {
                    keyframes: [
                        {
                            duration: 0,
                            opacity: 1,
                        },
                        {
                            duration: duration * 0.2, // 20%
                            easing: 'easeInOutQuad',
                            rotateZ: 80,
                        },
                        {
                            duration: duration * 0.2, // 40%
                            easing: 'easeInOutQuad',
                            rotateZ: 60,
                        },
                        {
                            duration: duration * 0.2, // 60%
                            easing: 'easeInOutQuad',
                            rotateZ: 80,
                        },
                        {
                            duration: duration * 0.2, // 80%
                            easing: 'easeInOutQuad',
                            rotateZ: 60,
                        },
                        {
                            duration: duration * 0.2, // 100%
                            opacity: 0,
                            rotateZ: 0,
                            easing: 'easeOutQuart',
                        },
                        {
                            duration: 0,
                            opacity: 1,
                        },
                    ],
                    transformOrigin: [
                        {
                            duration: 0,
                            value: `0% 0%`,
                        },
                        {
                            duration: duration * 0.8,
                            value: '0% 0%',
                        },
                        {
                            duration: duration * 0.2,
                            value: '50% 50%',
                            easing: 'easeOutQuart',
                        },
                    ],
                    translateY: [
                        {
                            value: 0,
                            duration: duration * 0.8,
                        },
                        {
                            duration: duration * 0.2,
                            easing: 'linear',
                            value: 700,
                        },
                        {
                            duration: 0,
                            value: 0,
                        },
                    ],
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Focus',
        name: 'text-focus',
        deprecated: true,
        category: 'Appear On Stage',
        compatibleElementTypes: [adstudio_1.ELEMENT_TYPE.TEXT],
        directions: [
            { name: 'Center', value: '-in' },
            { name: 'Expand', value: '-in-expand' },
            { name: 'Expand Forward', value: '-in-expand-fwd' },
            { name: 'Contract', value: '-in-contract' },
            { name: 'Contract Backward', value: '-in-contract-bck' },
        ],
        animationGenerator: function generateFocusAnimation({ rawDirectionName }) {
            return ({ duration, DOMElement }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                const animation = {
                    targets: DOMElement,
                    opacity: [0, 1],
                    filter: ['blur(12px)', 'blur(0px)'],
                    ...(['expand', 'contract'].includes(directionComponents[0]) && {
                        letterSpacing: [`${directionComponents[0] === 'expand' ? -0.5 : 1}em`, 0],
                    }),
                    ...(['forward', 'backward'].includes(directionComponents[1]) && {
                        perspective: [
                            {
                                duration: 0,
                                value: 500,
                            },
                            {
                                duration,
                                value: 500,
                            },
                            {
                                duration: 0,
                                value: 0,
                            },
                        ],
                        translateZ: [directionComponents[1] === 'forward' ? -800 : 300, 0],
                    }),
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Tracking',
        name: 'text-tracking',
        deprecated: true,
        category: 'Appear On Stage',
        compatibleElementTypes: [adstudio_1.ELEMENT_TYPE.TEXT],
        directions: [
            { name: 'Expand', value: '-in-expand' },
            { name: 'Expand Forward', value: '-in-expand-fwd' },
            { name: 'Expand Forward Top', value: '-in-expand-fwd-top' },
            { name: 'Expand Forward Bottom', value: '-in-expand-fwd-bottom' },
            { name: 'Contract', value: '-in-contract' },
            { name: 'Contract Backward', value: '-in-contract-bck' },
            { name: 'Contract Backward Top', value: '-in-contract-bck-top' },
            { name: 'Contract Backward Bottom', value: '-in-contract-bck-bottom' },
        ],
        animationGenerator: function generateTrackingAnimation({ rawDirectionName }) {
            return ({ duration, DOMElement }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                const letterSpacing = [directionComponents[0] === 'expand' ? '-0.5em' : '1em', '0em'];
                const translateZ = ['forward', 'backward'].includes(directionComponents[1])
                    ? [directionComponents[1] === 'forward' ? -700 : 400, 0]
                    : undefined;
                const translateY = ['top', 'bottom'].includes(directionComponents[2])
                    ? [(directionComponents[1] === 'forward' ? -500 : -300) * (directionComponents[2] === 'top' ? 1 : -1), 0]
                    : undefined;
                const animation = {
                    targets: DOMElement,
                    opacity: [0, 1],
                    ...(letterSpacing && { letterSpacing }),
                    ...(translateY && { translateY }),
                    ...(translateZ && {
                        perspective: [
                            {
                                value: 400,
                                duration: 0,
                            },
                            {
                                value: 400,
                                duration,
                            },
                            {
                                value: 0,
                                duration: 0,
                            },
                        ],
                        translateZ,
                    }),
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Blur',
        name: 'text-blur',
        category: 'Appear On Stage',
        directions: [
            { name: 'Center', value: '-in' },
            { name: 'Expand', value: '-in-expand' },
            { name: 'Expand Forward', value: '-in-expand-fwd', deprecated: true },
            { name: 'Contract', value: '-in-contract' },
            { name: 'Contract Backward', value: '-in-contract-bck', deprecated: true },
        ],
        animationGenerator: function generateBlurAnimation({ rawDirectionName }) {
            return ({ duration }) => {
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                const animation = {
                    opacity: [0, 1],
                    filter: ['blur(12px)', 'blur(0px)'],
                    ...(['expand', 'contract'].includes(directionComponents[0]) && {
                        scale: [
                            {
                                value: directionComponents[0] === 'expand' ? 0 : 2,
                                duration: 0,
                            },
                            { value: 1, duration },
                        ],
                    }),
                    ...(['forward', 'backward'].includes(directionComponents[1]) && {
                        perspective: [
                            {
                                duration: 0,
                                value: 500,
                            },
                            {
                                duration,
                                value: 500,
                            },
                            {
                                duration: 0,
                                value: 0,
                            },
                        ],
                        translateZ: [directionComponents[1] === 'forward' ? -400 : 400, 0],
                    }),
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Slow Zoom',
        name: 'bg-kenburns',
        category: 'Background Animations',
        compatibleElementTypes: [adstudio_1.ELEMENT_TYPE.BACKGROUND],
        directions: [
            { name: 'Top', value: '-top' },
            { name: 'Top Right', value: '-top-right' },
            { name: 'Right', value: '-right' },
            { name: 'Bottom Right', value: '-bottom-right' },
            { name: 'Bottom', value: '-bottom' },
            { name: 'Bottom Left', value: '-bottom-left' },
            { name: 'Left', value: '-left' },
            { name: 'Top Left', value: '-top-left' },
        ],
        animationGenerator: function generateSlowZoomAnimation({ rawDirectionName }) {
            return ({ duration }) => {
                // Removed the translations because the end result looked better just with the transform origin and the scale
                const directionComponents = rawDirectionName
                    .split(' ')
                    .map((directionComponent) => directionComponent.toLowerCase());
                let transformOrigin;
                const scale = [1, 1.25];
                switch (directionComponents.length) {
                    case 1:
                        transformOrigin = [
                            {
                                value: `${directionComponents[0] === 'left' ? 16 : directionComponents[0] === 'right' ? 84 : 50}% ${directionComponents[0] === 'top' ? 16 : directionComponents[0] === 'bottom' ? 84 : 50}%`,
                                duration: 0,
                            },
                            {
                                value: `${directionComponents[0] === 'left' ? 0 : directionComponents[0] === 'right' ? 100 : 50}% ${directionComponents[0] === 'top' ? 0 : directionComponents[0] === 'bottom' ? 100 : 50}%`,
                                duration,
                            },
                        ];
                        break;
                    case 2:
                        transformOrigin = [
                            {
                                value: `${directionComponents[1] === 'left' ? 16 : directionComponents[1] === 'right' ? 84 : 50}% ${directionComponents[0] === 'top' ? 16 : directionComponents[0] === 'bottom' ? 84 : 50}%`,
                                duration: 0,
                            },
                            {
                                value: `${directionComponents[1] === 'left' ? 0 : directionComponents[1] === 'right' ? 100 : 50}% ${directionComponents[0] === 'top' ? 0 : directionComponents[0] === 'bottom' ? 100 : 50}%`,
                                duration,
                            },
                        ];
                        break;
                    default:
                        break;
                }
                const animation = {
                    ...(scale && { scale }),
                    ...(transformOrigin && {
                        transformOrigin: [...transformOrigin],
                    }),
                };
                return animation;
            };
        },
    },
    {
        nameShown: 'Pan',
        name: 'bg-pan',
        category: 'Background Animations',
        compatibleElementTypes: [adstudio_1.ELEMENT_TYPE.BACKGROUND],
        directions: [
            {
                name: 'Top',
                value: '-top',
                [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ element, DOMElement, }) => {
                    let animationObject;
                    switch (element.background.type) {
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.VIDEO:
                            animationObject = {
                                ...animationObject,
                                ...{ top: [`${parseInt(element.posY) - 1000}`, `${element.posY}`] },
                            };
                            break;
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.IMAGE:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    backgroundPosition: [
                                        `${element.posX}% ${parseInt(element.posY) + 100}%`,
                                        `${element.posX}% ${element.posY}%`,
                                    ],
                                },
                                targets: DOMElement,
                            };
                            break;
                        default:
                            break;
                    }
                    return animationObject;
                },
            },
            {
                name: 'Top Right',
                value: '-tr',
                [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ element, DOMElement, }) => {
                    let animationObject;
                    switch (element.background.type) {
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.VIDEO:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    top: [`${parseInt(element.posY) - 1000}`, `${element.posY}`],
                                    left: [`${parseInt(element.posX) + 1000}`, `${element.posX}`],
                                },
                            };
                            break;
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.IMAGE:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    backgroundPosition: [
                                        `${parseInt(element.posX) - 100}% ${parseInt(element.posY) + 100}%`,
                                        `${element.posY}% ${element.posY}%`,
                                    ],
                                    targets: DOMElement,
                                },
                            };
                            break;
                        default:
                            break;
                    }
                    return animationObject;
                },
            },
            {
                name: 'Right',
                value: '-right',
                [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ element, DOMElement, }) => {
                    let animationObject;
                    switch (element.background.type) {
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.VIDEO:
                            animationObject = {
                                ...animationObject,
                                ...{ left: [`${parseInt(element.posX) + 1000}`, `${element.posX}`] },
                            };
                            break;
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.IMAGE:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    backgroundPosition: [
                                        `${parseInt(element.posX) - 100}% ${element.posY}%`,
                                        `${element.posX}% ${element.posY}%`,
                                    ],
                                },
                                targets: DOMElement,
                            };
                            break;
                        default:
                            break;
                    }
                    return animationObject;
                },
            },
            {
                name: 'Bottom Right',
                value: '-br',
                [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ element, DOMElement, }) => {
                    let animationObject;
                    switch (element.background.type) {
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.VIDEO:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    top: [`${parseInt(element.posY) + 1000}`, `${element.posY}`],
                                    left: [`${parseInt(element.posX) + 1000}`, `${element.posX}`],
                                },
                            };
                            break;
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.IMAGE:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    backgroundPosition: [
                                        `${parseInt(element.posX) - 100}% ${parseInt(element.posY) - 100}%`,
                                        `${element.posX}% ${element.posY}%`,
                                    ],
                                    targets: DOMElement,
                                },
                            };
                            break;
                        default:
                            break;
                    }
                    return animationObject;
                },
            },
            {
                name: 'Bottom',
                value: '-bottom',
                [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ element, DOMElement, }) => {
                    let animationObject;
                    switch (element.background.type) {
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.VIDEO:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    top: [`${parseInt(element.posY) + 1000}`, `${element.posY}`],
                                },
                            };
                            break;
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.IMAGE:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    backgroundPosition: [
                                        `${element.posX}% ${parseInt(element.posY) - 100}%`,
                                        `${element.posX}% ${element.posY}%`,
                                    ],
                                    targets: DOMElement,
                                },
                            };
                            break;
                        default:
                            break;
                    }
                    return animationObject;
                },
            },
            {
                name: 'Bottom Left',
                value: '-bl',
                [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ element, DOMElement, }) => {
                    let animationObject;
                    switch (element.background.type) {
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.VIDEO:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    top: [`${parseInt(element.posY) + 1000}`, `${element.posY}`],
                                    left: [`${parseInt(element.posX) - 1000}`, `${element.posX}`],
                                },
                            };
                            break;
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.IMAGE:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    backgroundPosition: [
                                        `${parseInt(element.posX) + 100}% ${parseInt(element.posY) - 100}%`,
                                        `${element.posX}% ${element.posY}%`,
                                    ],
                                    targets: DOMElement,
                                },
                            };
                            break;
                        default:
                            break;
                    }
                    return animationObject;
                },
            },
            {
                name: 'Left',
                value: '-left',
                [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ element, DOMElement, }) => {
                    let animationObject;
                    switch (element.background.type) {
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.VIDEO:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    left: [`${parseInt(element.posX) - 1000}`, `${element.posX}`],
                                },
                            };
                            break;
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.IMAGE:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    backgroundPosition: [
                                        `${parseInt(element.posX) + 100}% ${element.posY}%`,
                                        `${element.posX}% ${element.posY}%`,
                                    ],
                                    targets: DOMElement,
                                },
                            };
                            break;
                        default:
                            break;
                    }
                    return animationObject;
                },
            },
            {
                name: 'Top Left',
                value: '-tl',
                [adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG]: ({ element, DOMElement, }) => {
                    let animationObject;
                    switch (element.background.type) {
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.VIDEO:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    top: [`${parseInt(element.posY) - 1000}`, `${element.posY}`],
                                    left: [`${parseInt(element.posX) - 1000}`, `${element.posX}`],
                                },
                            };
                            break;
                        case adstudio_1.ELEMENT_BACKGROUND_TYPE.IMAGE:
                            animationObject = {
                                ...animationObject,
                                ...{
                                    backgroundPosition: [
                                        `${parseInt(element.posX) + 100}% ${parseInt(element.posY) + 100}%`,
                                        `${element.posX}% ${element.posY}%`,
                                    ],
                                    targets: DOMElement,
                                },
                            };
                            break;
                        default:
                            break;
                    }
                    return animationObject;
                },
            },
        ],
    },
];
availableAnimations.forEach((animation) => {
    // When there are no directions, the animation itself looks like one
    const directions = animation.directions ?? [animation];
    directions.forEach((direction) => {
        if (animation.animationGenerator && !direction[adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG])
            direction[adstudio_1.ELEMENT_ANIMATION_STYLE.ANIME_CONFIG] = animation.animationGenerator({
                rawDirectionName: direction.name,
            });
        // console.log('generating animation automatically using direction name', direction)
    });
});
exports.default = availableAnimations;
